import React, { useContext, useState, useRef } from 'react';
import { Container, Row, Col, Table, Spinner, Form, InputGroup, Button, Accordion } from 'react-bootstrap';
import $ from 'jquery';
import ReactToPrint from "react-to-print";
import generatePDF from 'react-to-pdf';
import { AppContext } from '../App';


export const IncompleteTokenReport = () => {
	const { incompleteTokenReport, setIncompleteTokenReport, getDate, postCall, getLoad, setGetLoad, downloadExcel } = useContext(AppContext);
	const [filename, setFilename] = useState('report_incomplete_token.xlsx');
	const tableRef = useRef(null);

	const getReport = (e) => {
		e.preventDefault();
		let start = e.target.start.value;
		let end = e.target.end.value;
		if (start !== "" && end !== "") {
			setGetLoad(true)
			postCall('api/bnr/get/not/completed/token/report/', { start_date: start, end_date: end }).then(res => {
				setIncompleteTokenReport(res.data);
				setFilename(`report_incomplete_token_${start}_${end}.xlsx`);
				setGetLoad(false);
			}).catch(err => {
				setGetLoad(false);
			});
		}
	}

	const formatExcel = () => {
		if (incompleteTokenReport !== undefined && Object.keys(incompleteTokenReport).length > 0) {
			let data = [];
			Object.keys(incompleteTokenReport).map(tkn => {
				let services = "";
				if (incompleteTokenReport[tkn].service !== undefined && Object.keys(incompleteTokenReport[tkn].service).length > 0) {
					Object.keys(incompleteTokenReport[tkn].service).map(s => {
						services += incompleteTokenReport[tkn].service[s].service + ", ";
					})
				}
				data.push({
					'Created Time': incompleteTokenReport[tkn].created_time,
					'Token': incompleteTokenReport[tkn].token_no,
					'Customer Name': incompleteTokenReport[tkn].customer_name,
					'Customer Phone': incompleteTokenReport[tkn].customer_phone,
					'Customer Address': incompleteTokenReport[tkn].customer_address,
					'Staff': incompleteTokenReport[tkn].token_created_by,
					'Services': services
				});
			});
			return data;
		}
	}

	return (
		<div className='container-fluid'>
			<div className='grid4by6 align-items-center justify-content-between p-2 mb-2 bgp br-3'>
				{
					getLoad ? (
						<div className="d-grid py-2">
							<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>
						</div>
					) : (
						<span className='text-white' >Incomplete token report</span>
					)
				}
				<Form onSubmit={getReport} >
					<Row>
						<Col xs={12} sm={4} md={4} >
							<InputGroup className="br-3">
								<InputGroup.Text className="br-3" id="inputGroup-sizing-default">From</InputGroup.Text>
								<Form.Control name="start" type="date" defaultValue={getDate()} className="br-3" />
							</InputGroup>
						</Col>
						<Col xs={12} sm={4} md={4} >
							<InputGroup className="br-3">
								<InputGroup.Text className="br-3" id="inputGroup-sizing-default">To</InputGroup.Text>
								<Form.Control name="end" type="date" defaultValue={getDate()} className="br-3" />
							</InputGroup>
						</Col>
						<Col xs={12} sm={4} md={4} className="d-grid" >
							<Button type="submit" className="btn-t1-r br-3" >Get Report</Button>
						</Col>
					</Row>
				</Form>
			</div>
			{
				incompleteTokenReport !== undefined && Object.keys(incompleteTokenReport).length > 0 ? (
					<div className='d-flex justify-content-end align-items-center mb-2 gap-2' >
						<span>Download</span>
						<Button className="br-1" onClick={() => {
							downloadExcel(formatExcel(), filename);
						}} size='sm' variant='success' ><i className='bi bi-download' ></i> Excel</Button>
						<Button onClick={() => {
							generatePDF(tableRef, filename);
						}} size='sm' className='br-1' variant='success' ><i className='bi bi-download' ></i> Pdf</Button>
						<ReactToPrint
							trigger={() => <Button className='br-1' variant='success' size='sm'><i className="bi bi-printer"></i> Print</Button>}
							content={() => tableRef.current}
						/>
					</div>
				) : null
			}
			<div ref={tableRef}>
				{
					incompleteTokenReport !== undefined && Object.keys(incompleteTokenReport).length > 0 ? (
						<Table bordered className="tbl-bg-blue" >
							<thead>
								<tr className="tp2">
									<th>Date</th>
									<th>Token</th>
									<th>Staff</th>
									<th>Customer</th>
									<th>Services</th>
								</tr>
							</thead>
							<tbody>
								{
									Object.keys(incompleteTokenReport).map((tkn, s_i) => (
										<tr key={`incomplete_${s_i}`} className="tp2">
											<td>
												<div className='d-grid'>
													<span className='tp2' >{incompleteTokenReport[tkn].date}</span>
													<span className='tp2 f14' >{incompleteTokenReport[tkn].created_time}</span>
												</div>
											</td>
											<td><span className="tp2 f18">{incompleteTokenReport[tkn].token_no}</span></td>
											<td><span className="tp2">{incompleteTokenReport[tkn].token_created_by}</span></td>
											<td>
												<div className='d-grid'>
													<span className="tp2">{incompleteTokenReport[tkn].customer_name}</span>
													<span className="tp2 f14">{incompleteTokenReport[tkn].customer_phone}</span>
													<span className="tp3 f12">{incompleteTokenReport[tkn].customer_address}</span>
												</div>
											</td>
											<td>
												{
													incompleteTokenReport[tkn].service !== undefined && Object.keys(incompleteTokenReport[tkn].service).length > 0 ? (
														Object.keys(incompleteTokenReport[tkn].service).map((ser, seri) => (
															<span className="d-grid tp2">{incompleteTokenReport[tkn].service[ser].service}</span>
														))
													) : ''
												}
											</td>
										</tr>
									))
								}
							</tbody>
						</Table>
					) : 'Report Not found!'

				}
			</div>
		</div>
	)
}